import { render } from "./serviceDetail.vue?vue&type=template&id=0c7e430b&scoped=true"
import script from "./serviceDetail.vue?vue&type=script&lang=js"
export * from "./serviceDetail.vue?vue&type=script&lang=js"

import "./serviceDetail.vue?vue&type=style&index=0&id=0c7e430b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7e430b"]])

export default __exports__